import { combineReducers } from "redux";
import actions from "../constants/rtoRequestApprovalsActions";
import {
  getFetchingState,
  getSuccessState,
  getErrorState,
  getResetState,
  createReducer,
} from "../utils/reducers";

const defaultState = {
  fetching: false,
  result: null,
  error: null,
};

const getRtoRequestList = createReducer(defaultState, {
  [actions.GET_RTO_REQUEST_LIST]: getFetchingState,
  [actions.GET_RTO_REQUEST_LIST_SUCCESS]: getSuccessState,
  [actions.GET_RTO_REQUEST_LIST_ERROR]: getErrorState,
  [actions.GET_RTO_REQUEST_LIST_CLEAR]: getResetState,
});

const updateRtoRequestStatus = createReducer(defaultState, {
  [actions.UPDATE_RTO_REQUEST_STATUS]: getFetchingState,
  [actions.UPDATE_RTO_REQUEST_STATUS_SUCCESS]: getSuccessState,
  [actions.UPDATE_RTO_REQUEST_STATUS_ERROR]: getErrorState,
  [actions.UPDATE_RTO_REQUEST_STATUS_CLEAR]: getResetState,
});

export default combineReducers({
  getRtoRequestList,
  updateRtoRequestStatus,
});
